import { registerMenu } from '../lib/common/header.js';

function display_my_schools_list($this_element) {
    var this_url = String(window.location);
    var this_user = $this_element.data('teacher_id');

    var base_uri = this_url.substring(0,this_url.indexOf('index.php',0)+9);

    var init_tag = '<p class="init-tag">Loading...</i></p>';
    var data_src = base_uri + '/school_assignment/get_staff_school_list/'+this_user;

    console.log("data_src :: "+data_src);
    console.log("$this_user :: "+this_user);
    $('#current_school_assignment_list').html(init_tag);
    $('#current_school_assignment_list').load(data_src);
}

const $headerRolesSelect = $('#newUserRole');

$headerRolesSelect.selectize();

$headerRolesSelect.change(() => {
    window.document.forms.roleSwitcherForm.submit();
});

const $headerSearchOptionSelect = $('#headerSearchOptionSelect');
$headerSearchOptionSelect.selectize();

const $roleChangerDropdownWrapper = $('#roleChangerDropdownWrapper');
const $roleChangerDropdownCTA = $('#roleChangerDropdownCTA');
const $roleChangerDropdownMenu = $('#roleChangerDropdownMenu');

$roleChangerDropdownCTA.click(() => {
    $roleChangerDropdownMenu.toggleClass('d-none').toggleClass('d-block');
});

var $supportLink = $('#supportLink');
var $supportDropdown = $('#supportDropdown');

$supportLink.click(function() {
    $supportDropdown.toggleClass('d-none').toggleClass('d-block');
});

// Added By Marc Audet, October 11, 2019
var $infoSchoolListLink = $('#infoSchoolListLink');
var $infoSchoolListDropdown = $('#infoSchoolListDropdown');

$infoSchoolListLink.click(function() {
    $infoSchoolListDropdown.toggleClass('d-none').toggleClass('d-block');
    display_my_schools_list($(this));
});

registerMenu($roleChangerDropdownWrapper, $roleChangerDropdownMenu);
registerMenu($supportLink, $supportDropdown);
registerMenu($infoSchoolListLink, $infoSchoolListDropdown);
